const calculateAngle = (aX: number, aY: number, bX: number, bY: number) => {
    // calculates the angle from point 1 to point 2
    const disX = aX - bX;
    const disY = aY - bY;
    return Math.atan2(disY, disX);
};

export { calculateAngle };
